import { useEffect, useRef } from "react";
import type { AppEvent } from "../api";
import { mutateStock } from "../desktop";
import { isAdminAccount } from "../lib/accountType";
import { getDesktopEventsHub } from "./desktopEventsHub";

/**
 * When stash is on, finished admin logins go to Available Stock → Pending.
 * Employee / Medium stay list-only on their pages (no stock claim).
 */
export function useStashRouter(opts: { enabled: boolean; stashEnabled: boolean }) {
  const routed = useRef(new Set<number>());

  useEffect(() => {
    if (!opts.enabled || !opts.stashEnabled) return;
    const hub = getDesktopEventsHub();

    const route = (ev: AppEvent) => {
      if (routed.current.has(ev.id)) return;
      if (ev.hidden || ev.status !== "ready") return;
      if ((ev.stockStage || "none") !== "none") return;
      if (!isAdminAccount(ev)) return;
      routed.current.add(ev.id);
      void mutateStock(ev.id, { stage: "pending", channel: "admin_user" }).catch(() => {
        routed.current.delete(ev.id);
      });
    };

    for (const ev of hub.getSnapshot()) route(ev);

    return hub.subscribeDiffs((changed) => {
      for (const ev of changed) route(ev);
    });
  }, [opts.enabled, opts.stashEnabled]);
}
